<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rI2azM/tc-custom/9781250188397.jpg?1729379531804" alt="This image is the cover for the book Spy Penguins, Spy Penguins"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spy Penguins, Spy Penguins
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Two young adventure-loving and gadget-obsessed penguins dream of joining the FBI (Frosty Bureau of Investigation) in Sam Hay's hilarious new illustrated chapter book series, <i>Spy Penguins</i>.</b><br/><br/>Adventure-loving penguin Jackson dreams of being a secret agent like his Uncle Bryn, who works for the Frosty Bureau of Investigation. Jackson and his gadget-inventing best friend Quigley might officially be too young to join the FBI, but they aren’t going to let that stop them! They just need to come up with the right plan to prove that they are worthy. <br/><br/>But when one of Q’s inventions goes dangerously wrong, Jackson suddenly finds himself dropped right in the middle off an FBI stakeout. There’s fishy business afoot at the city’s aquarium; rare fish are vanishing and not even the FBI can work out what’s going on. It’s up to Jackson and Quigley to solve the crime!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Hay, Marek Jagucki
      </h2>
      
      <p class="authorDescription body article"><P><B>Sam Hay</B> is the author of over thirty books for children including the Undead Pets series and <I>Stella and the Night Spirits</I>. Sam trained as a journalist in Edinburgh. After starting out in newspapers, Sam moved to London where she worked for BBC television for ten years. She still believes working on daily live television is the perfect brain-trainer for life!  Sam became a full-time writer when her first baby was born and now lives in Wales with her husband and two children who provide the inspiration for many of her stories.<br><br><B>Marek Jagucki</B> is a graduate of Falmouth School of Art and Design. He is a full-time illustrator and graphic designer based in Yorkshire, UK.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b3a2414